import { render, staticRenderFns } from "./InfoAndAuthBar.vue?vue&type=template&id=07407872&"
import script from "./InfoAndAuthBar.vue?vue&type=script&lang=js&"
export * from "./InfoAndAuthBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports